import { render, staticRenderFns } from "./AbnormalOrder.vue?vue&type=template&id=54185eca&"
import script from "./AbnormalOrder.vue?vue&type=script&lang=js&"
export * from "./AbnormalOrder.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports